import React, { useMemo } from 'react';
import type { SwampEventResult } from '../types';
import { TeamList } from './TeamList';
import { EventScoreList } from './EventScoreList';
import { TotalScoreBoard } from './TotalScoreBoard';
import { teamTotals, winningTeamNames } from '../scores';

interface EventResultsViewProps {
   result: SwampEventResult;
}

export function EventResultsView({ result }: EventResultsViewProps) {
   const teamNames = Object.keys(result.teams);
   const winners = useMemo(
      () => winningTeamNames(teamTotals(result.events, teamNames)),
      [result.events, teamNames]
   );

   return (
      <div className="swamp-results">
         <TeamList teams={result.teams} winners={winners} trophySrc={result.image} />
         <TotalScoreBoard events={result.events} teamNames={teamNames} />
         <EventScoreList events={result.events} teamNames={teamNames} />
      </div>
   );
}
